import { render, staticRenderFns } from "./computeCard.vue?vue&type=template&id=5d171ac6&scoped=true&"
import script from "./computeCard.vue?vue&type=script&lang=js&"
export * from "./computeCard.vue?vue&type=script&lang=js&"
import style0 from "./computeCard.vue?vue&type=style&index=0&id=5d171ac6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d171ac6",
  null
  
)

export default component.exports